import resource from '../../../services/purchase/generalReceipt'
import generalReceiptList from './generalReceiptList'
export default {
    namespaced: true,
    modules: {
        list: generalReceiptList
    },
    actions: {
        create(context, payload) {
            return new Promise((resolve, reject) => {
                resource.create(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            });
        },
        findByID(context, payload) {
            return new Promise((resolve, reject) => {
                resource.findByID(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error)
                })
            })
        },
        update(context, payload) {
            return new Promise((resolve, reject) => {
                resource.update(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            });
        },
        delete(context, payload) {
            return new Promise((resolve, reject) => {
                resource.remove(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        post(context, payload) {
            return new Promise((resolve, reject) => {
                resource.post(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        }
    } 
}